import React from "react";
import { Helmet } from "react-helmet-async";
import TeamAutoCarousel from "./TeamCarousel";
import { useLocation } from "react-router-dom";

const AboutUs = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search).get("highlight") || "";
  const highlightText = query.toLowerCase();

  return (
    <div className="min-h-screen bg-gray-100 font-sans">
      {/* SEO Metadata */}
      <Helmet>
        <title>Adithya Infinity</title>
        <meta
          name="description"
          content="Discover the story of Venkat Vedicharla, Managing Director of Adithya Infinity Pvt Ltd — an innovative IT company from Hyderabad focused on AI and digital transformation."
        />
        <meta
          name="keywords"
          content="
            Venkat Vedicharla, Venkat, CEO, Founder, Managing Director, 
            Adithya Infinity, Adhithya, V Adithya Infinity, 
            V Adithya Infinity, Adithya, Vedicherla, V Vedicharla, 
            Adhithya IT, Hyderabad Tech Company, AI Transformation,
            Indian Entrepreneur, Adhithya Pvt Ltd, Adhithya Founder"
        />
        <meta name="author" content="Adithya Infinity Pvt Ltd" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="About Us - Venkat Vedicharla" />
        <meta
          property="og:description"
          content="Meet Venkat Vedicharla, MD of Adithya Infinity — leading innovation in technology and AI solutions from Hyderabad."
        />
        <meta
          property="og:image"
          content="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=80"
        />
        <meta property="og:url" content="https://www.adhithyainfinity.com/about" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Venkat Vedicharla" />
        <meta
          name="twitter:description"
          content="Explore Venkat Vedicharla's leadership journey with Adithya Infinity Pvt Ltd, a forward-thinking IT firm in Hyderabad."
        />
        <meta
          name="twitter:image"
          content="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=80"
        />
      </Helmet>

      {/* Hero Section */}
      <div
        className="relative h-[60vh] bg-cover bg-center flex items-center justify-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1400&q=80')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 text-center text-white px-6 animate-fade-in">
          <h1 className="text-5xl md:text-6xl font-extrabold drop-shadow-lg">
            About Us
          </h1>
        </div>
      </div>

      {/* Main About Section */}
      <div className="relative -mt-24 z-10 px-4 md:px-10">
        <div className="bg-white/90 backdrop-blur-lg shadow-2xl rounded-3xl p-10 max-w-6xl mx-auto animate-fade-in-up">

          {/* Two-Column Layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
            <div>
              <h2 className="text-3xl font-bold text-purple-800 mb-4">
                About Venkat Vedicharla
              </h2>
              <p className="text-gray-800 leading-relaxed text-justify">
                 {highlightText ? (
                  <span
                  dangerouslySetInnerHTML={{__html: `...your content...`.replace(new RegExp(`(${highlightText})`, "gi"),"<mark>$1</mark>"),}}/>
                ) : (
                  "Venkat Vedicharla is the Managing Director of Adithya Infinity Private Limited, a Hyderabad-based service-oriented IT company focused on AI-driven technology solutions and digital transformation. A forward-thinking tech venture officially inaugurated on April 17th, 2025, in Hyderabad. With over 20 years of total industry experience, Venkat brings a unique blend of expertise across both non-IT and IT sectors. He has 15 years of strong experience in non-IT sales and marketing, and 5 years as a Senior Software Engineer at top Level 5 IT companies in India. This dual-domain exposure gives him a competitive edge in strategic leadership and execution."
                )}
              </p>
            </div>

            <div className="flex flex-col items-center text-center">
              <div className="w-72 h-72 rounded-full overflow-hidden shadow-xl border-4 border-purple-500 mb-6">
                <img
                  src={require("../../assets/venkat.JPG")}
                  alt="CEO"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="text-2xl font-bold text-gray-900 mb-2">Venkat Vedicharla</h4>
              <p className="text-purple-600 font-semibold text-lg">Managing Director</p>
            </div>
          </div>

          {/* Achievements */}
          <div className="mt-10 mb-10">
            <h3 className="text-xl font-semibold text-purple-700 mb-4 text-center">
              Key Achievements & Contributions:
            </h3>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-4 text-gray-700 list-disc pl-6 pr-2">
              <li>Building scalable digital platforms and mentoring young talent</li>
              <li className="whitespace-nowrap">Delivering impactful results through innovation and smart business practices</li>
              <li>Running structured internship programs with real-time project exposure</li>
              <li>Inspiring speaker on entrepreneurship, leadership, and technology</li>
              <li>Acted in Indian cinema including Pushpa 2 and Gurram Paapi Reddy</li>
              <li>Providing career development guidance to freshers and professionals</li>
              <li>Driving progress at the intersection of tech, business, and creativity</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Carousel Section */}
      <TeamAutoCarousel />
    </div>
  );
};

export default AboutUs;
